module.exports = __webpack_public_path__ + "static/img/15.878edd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/15.png
// module id = 6MK1
// module chunks = 0